<div class="view-alert">
  <div class="header">
    <div class="d-flex justify-content-between">
      <h1 class="modal-title m-auto pr-2">
        <app-with-tooltip [showHelpCursor]="true">
          {{ title }} {{ 'SETTING' | translate }}</app-with-tooltip
        >
      </h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="closeDialog()"
      />
    </div>

    <div class="d-flex mt-4 pt-2 pb-2 mx-1">
      <h2 class="heading1 m-auto px-4 text-center">
        {{ 'QUICK_ACTION_TO_SOLVE' | translate }}
      </h2>
    </div>
  </div>
  <div class="main-container py-2 px-3">
    <div class="pb-95">
      <div class="d-flex flex-row justify-content-start my-3 message">
        <img
          class="check"
          src="/assets/svg/ico-circle-check-black.svg"
          alt="check circle"
        />
        <span class="dec pl-2">
          {{ 'GET_NEW_BATTERIES' | translate }}
        </span>
      </div>
      <div class="d-flex flex-row justify-content-start my-3 message">
        <img
          class="check"
          src="/assets/svg/ico-circle-check-black.svg"
          alt="check circle"
        />
        <span class="dec pl-2">
          {{ 'REMOVE_BACK_APNEL' | translate }}
        </span>
      </div>
      <div class="d-flex flex-row justify-content-start my-3 message">
        <img
          class="check"
          src="/assets/svg/ico-circle-check-black.svg"
          alt="check circle"
        />
        <span class="dec pl-2">
          {{ 'REPLACE_OLD_BATTERIES' | translate }}
        </span>
      </div>
      <div class="d-flex flex-row justify-content-start my-3 message">
        <img
          class="check"
          src="/assets/svg/ico-circle-check-black.svg"
          alt="check circle"
        />
        <span class="dec pl-2">
          {{ 'LOCK_WILL_AUTO_START' | translate }}
        </span>
      </div>
    </div>

    <div class="row bottom-container justify-content-center pb-2">
      <div
        class="help d-flex flex-column justify-content-center align-items-center text-center pb-3 mx-5"
      >
        <span>
          {{ 'DID_WE_RESOLVE_YOUR_PROBLEM' | translate }}
        </span>
      </div>
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="navigateToKwikset()"
        >
          {{ 'GET_MORE_HELP' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
